import { DriverCommission } from "models/DriverCommission";
import React from "react";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { format } from "date-fns";
import { GenerateReportPDF } from "./GeneratePDF";
import moment from "moment";

export interface Props {
  isOpen: boolean;
  handlePopup: () => void;
  driverBill?: DriverCommission & { previousWeek?: any };
  dates: any;
}

const DriverReportView: React.FC<Props> = ({ isOpen, handlePopup, driverBill, dates }: Props) => {

  const handleDownload = () => {
    if (!driverBill) return;

    const billData = {
      ...driverBill,
      orderDetails: orders,
      previousWeek: driverBill.previousWeek,
    };


    GenerateReportPDF(billData);
  };

  const closeBtn = (
    <button onClick={handlePopup} type="button" className="btn-close" />
  );

  const formatActiveTime = (seconds: number): string => {
    if (!seconds) return "0h 0m";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m}m`;
  };

  const orders =
    [...(driverBill?.orderDetails || [])].sort(
      (a: any, b: any) =>
        new Date(a.statusDetails.date).getTime() -
        new Date(b.statusDetails.date).getTime()
    );


  const totalOrderAmount = orders.reduce((t, o) => t + (o.subTotal || 0), 0);
  const totalCommission = orders.reduce((t, o) => {
    const perc = parseFloat(String(driverBill?.driverDetails?.percentage ?? "0"))

    return t + (o.subTotal || 0) * (perc / 100);
  }, 0);
  const totalActiveSeconds = orders.reduce((t, o) => t + (o.activeSeconds || 0), 0);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpen}
        toggle={handlePopup}
        size="xl"
        backdrop="static"
        style={{ maxWidth: "1400px" }}
      >
        <ModalHeader toggle={handlePopup} close={closeBtn}></ModalHeader>

        <ModalBody className="px-lg-4" style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <h4 className="bg-primary bg-opacity-25 popover-header py-2 text-center">
            Invoice — Current Week
          </h4>

          {/* Header Info */}
          <div className="mx-lg-3 px-lg-4 small mt-4">
            <Row className="pt-2">
              <Col lg="3" className="fw-semibold">Invoice Number</Col>
              <Col lg="1">:</Col>
              <Col lg="8">{driverBill?.zuluId}</Col>
            </Row>

            <Row className="pt-2">
              <Col lg="3" className="fw-semibold">Date Range</Col>
              <Col lg="1">:</Col>
              <Col lg="8">
                {format(new Date(dates.date1), "MMMM do, yyyy")} to{" "}
                {format(new Date(dates.date2), "MMMM do, yyyy")}
              </Col>
            </Row>

            <Row className="pt-2">
              <Col lg="3" className="fw-semibold">Driver ID</Col>
              <Col lg="1">:</Col>
              <Col lg="8">{driverBill?.driverDetails?.customerId}</Col>
            </Row>

            <Row className="pt-2">
              <Col lg="3" className="fw-semibold">Driver Name</Col>
              <Col lg="1">:</Col>
              <Col lg="8">
                {driverBill?.driverDetails?.firstName}{" "}
                {driverBill?.driverDetails?.lastName}
              </Col>
            </Row>

            <Row className="pt-2">
              <Col lg="3" className="fw-semibold">Total No of Orders</Col>
              <Col lg="1">:</Col>
              <Col lg="8">
                {String(driverBill?.totalOrders || 0).padStart(2, "0")}
              </Col>
            </Row>
          </div>

          <div className="mt-5 mx-lg-3 px-lg-4">
            <h5 className="mb-3">Order Details</h5>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Completed Date</th>
                    <th>Order ID</th>
                    {/* <th>Pick-up</th> */}
                    <th>Delivery</th>
                    {/* <th>No of Items</th> */}
                    {/* <th className="text-end">Order Value</th> */}
                    <th className="text-end">Commission</th>
                    {/* <th className="text-center">Active Time</th> */}
                  </tr>
                </thead>

                <tbody>
                  {orders.map((order: any) => {
                    const commission =
                      (parseFloat(String(driverBill?.driverDetails?.percentage ?? "0"))
                        /
                        100) *
                      (order?.subTotal || 0);

                    return (
                      <tr key={order._id}>
                        {/* <td>{moment(order.createdAt).format("DD.MM.YYYY")}</td> */}
                        <td>{order.statusDetails.date}</td>
                        <td>{order.uniqueId}</td>
                        {/* <td>{order?.pickUpAddress?.city}</td> */}
                        <td>{order?.deliveryAddress?.city}</td>
                        {/* <td>
                          {order.totalItems} {order.totalItems === "1" ? "Pc" : "Pcs"}
                        </td> */}
                        {/* <td className="text-end">${order.subTotal?.toFixed(2)}</td> */}
                        <td className="text-end">${commission.toFixed(2)}</td>
                        {/* <td className="text-center">
                          {formatActiveTime(order.activeSeconds || 0)}
                        </td> */}
                      </tr>
                    );
                  })}


                  <tr className="table-primary fw-bold">
                    <td colSpan={3} className="text-center">Total</td>
                    {/* <td className="text-end">${totalOrderAmount.toFixed(2)}</td> */}
                    <td className="text-end">${totalCommission.toFixed(2)}</td>
                    {/* <td className="text-center">{formatActiveTime(totalActiveSeconds)}</td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <button onClick={handleDownload} className="btn btn-primary btn-sm px-3 ms-lg-4">
            Download PDF
          </button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default DriverReportView;
